export { default as TableCellData } from './table-cell-data';
export type { TableCellProps } from './table-cell-data.types';
